<div
  role="group"
  ngbDropdown
  container="body"
  placement="bottom-right"
  display="dynamic"
  [autoClose]="false"
  class="flex justify-end w-full"
  (openChange)="onDropdownOpenChange($event)"
>
  <button
    type="button"
    data-toggle="dropdown"
    class="btn-icon flex flex-center text-gray-60 hover:text-black-base p-1"
    aria-haspopup="true"
    ngbDropdownToggle
  >
    <i class="fa fa-cog text-md" aria-hidden="true"></i>
  </button>
  <div ngbDropdownMenu class="w-[40%] md:w-[400px] p-0">
    <div class="flex flex-col">
      <div class="flex justify-between px-2 py-1 items-center">
        <span>{{ 'RegisterService::CustomizeColumns' | abpLocalization }}</span>
      </div>
      <!-- T057: Drag-and-drop reorderable column list -->
      <div
        cdkDropList
        class="column-list-container overflow-auto px-2 grid grid-cols-2 gap-x-2"
        (cdkDropListDropped)="onColumnDrop($event)"
        role="list"
        [attr.aria-label]="'RegisterService::ColumnList' | abpLocalization"
      >
        <div
          *ngFor="let col of orderedColumns"
          cdkDrag
          [cdkDragDisabled]="isMandatoryColumn(col.key)"
          class="column-item flex items-center form-check p-2 rounded"
          [class.cdk-drag-disabled]="isMandatoryColumn(col.key)"
          role="listitem"
        >
          <span
            class="drag-handle"
            [title]="
              isMandatoryColumn(col.key)
                ? ('RegisterService::MandatoryColumnCannotReorder' | abpLocalization)
                : ('RegisterService::DragToReorder' | abpLocalization)
            "
            [attr.aria-label]="
              isMandatoryColumn(col.key)
                ? ('RegisterService::MandatoryColumnCannotReorder' | abpLocalization)
                : ('RegisterService::DragToReorder' | abpLocalization)
            "
          >
            <i class="fa fa-grip-vertical" aria-hidden="true"></i>
          </span>
          <input
            type="checkbox"
            class="form-check-input"
            [id]="col.key"
            (change)="onSelect($event, { key: col.key, value: keys[col.key] })"
            [checked]="keys[col.key]"
            [attr.aria-label]="
              (columnsTranslationKey[col.key] | abpLocalization) +
              (isMandatoryColumn(col.key)
                ? ' (' + ('RegisterService::Required' | abpLocalization) + ')'
                : '')
            "
            [attr.aria-describedby]="isMandatoryColumn(col.key) ? col.key + '-required' : null"
          />
          <label class="form-check-label flex-1 cursor-pointer mx-2" [attr.for]="col.key">
            {{ columnsTranslationKey[col.key] | abpLocalization }}
            <span
              *ngIf="isMandatoryColumn(col.key)"
              class="mandatory-badge"
              [id]="col.key + '-required'"
              role="status"
            >
              {{ 'RegisterService::Required' | abpLocalization }}
            </span>
          </label>
        </div>
      </div>
      <!-- T063: Reset to Default button -->
      <div
        class="flex justify-between !gap-2 border-t border-gray-20 !p-4"
        role="group"
        [attr.aria-label]="'RegisterService::ColumnActions' | abpLocalization"
      >
        <button
          type="button"
          class="!px-4 !py-2 flex size-full flex-center bg-white border border-gray-20 hover:text-black-base text-gray-60 rounded"
          (click)="onCancel()"
          [attr.aria-label]="'AbpUi::Cancel' | abpLocalization"
        >
          {{ 'AbpUi::Cancel' | abpLocalization }}
        </button>
        <button
          class="!px-4 !py-2 flex gap-1 size-full flex-center bg-blue-50 border border-blue-50 hover:bg-blue text-white rounded"
          (click)="changePreferences()"
          [attr.aria-label]="'AbpUi::Apply' | abpLocalization"
        >
          {{ 'AbpUi::Apply' | abpLocalization }}
        </button>
      </div>
    </div>
  </div>
</div>
